import get from 'lodash.get';
import getSiteData from './site-data';

const defaultProperties = {};

const getSiteProperties = (rootState) => {
  const siteData = getSiteData(rootState);

  return get(siteData, 'properties', defaultProperties);
};

export default getSiteProperties;
